import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AppHeader from "@/components/AppHeader";
import Notch from "@/pages/Notch";
import Auth from "@/pages/Auth";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import PhotoLog from "@/pages/PhotoLog";
import SharedPlan from "@/pages/SharedPlan";
import BillingSuccess from "@/pages/BillingSuccess";
import Privacy from "@/pages/Privacy";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="pt-20 text-center text-sm text-[#888]">Loading…</div>;
  if (user === false) return <Navigate to="/auth" state={{ from: loc.pathname }} replace />;
  return children;
}

function Layout() {
  return (
    <>
      <AppHeader />
      <Routes>
        <Route path="/" element={<Protected><Notch /></Protected>} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/photolog" element={<Protected><PhotoLog /></Protected>} />
        <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
        <Route path="/share/:share_id" element={<SharedPlan />} />
        <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Layout />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
